import CryptoJS from 'crypto-js';

const DEFAULT_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

const getDefaultKey = () => {

  if (!DEFAULT_KEY || DEFAULT_KEY.trim() === '') {

    throw new Error('REACT_APP_ENCRYPTION_KEY no está configurada en el archivo .env');

  }

  return DEFAULT_KEY;

};

const deriveKey = (key) => {

  const md5Hash = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(key));

  const keyBytes = md5Hash.clone();
  keyBytes.concat(CryptoJS.lib.WordArray.create(md5Hash.words.slice(0, 2), 8));

  return keyBytes;

};

export const encrypt = (text, key = getDefaultKey()) => {

  const keyBytes = deriveKey(key);

  const encrypted = CryptoJS.TripleDES.encrypt(
    CryptoJS.enc.Utf8.parse(text),
    keyBytes,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);

};

export const decrypt = (encryptedText, key = getDefaultKey()) => {

  const keyBytes = deriveKey(key);

  const decrypted = CryptoJS.TripleDES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
    },
    keyBytes,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
  
};